import React from "react";

export function SvgVeicoli() {
  return (
    <svg
      width="81"
      height="56"
      viewBox="0 0 81 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Modalit&#195;&#160;_Isolamento" clipPath="url(#clip0_1089_2380)">
        <path
          id="Vector"
          d="M24.3984 19.4453V47.3214H52.4532V19.4453H24.3984ZM45.2515 40.1656H31.6037V26.6046H45.2515V40.1656Z"
          fill="#A6CAED"
        />
        <g id="Group">
          <path
            id="Vector_2"
            d="M22.9356 28.2224H12.2845C11.9887 28.2224 11.75 27.9851 11.75 27.6913C11.75 27.3974 11.9887 27.1602 12.2845 27.1602H22.9356C23.2313 27.1602 23.4701 27.3974 23.4701 27.6913C23.4701 27.9851 23.2313 28.2224 22.9356 28.2224Z"
            fill="#17324D"
          />
          <path
            id="Vector_3"
            d="M22.9356 32.281H12.2845C11.9887 32.281 11.75 32.0437 11.75 31.7499C11.75 31.456 11.9887 31.2188 12.2845 31.2188H22.9356C23.2313 31.2188 23.4701 31.456 23.4701 31.7499C23.4701 32.0437 23.2313 32.281 22.9356 32.281Z"
            fill="#17324D"
          />
          <path
            id="Vector_4"
            d="M22.9356 36.3415H12.2845C11.9887 36.3415 11.75 36.1043 11.75 35.8104C11.75 35.5165 11.9887 35.2793 12.2845 35.2793H22.9356C23.2313 35.2793 23.4701 35.5165 23.4701 35.8104C23.4701 36.1043 23.2313 36.3415 22.9356 36.3415Z"
            fill="#17324D"
          />
          <path
            id="Vector_5"
            d="M78.862 56.0014H2.13805C0.958559 56.0014 0 55.0489 0 53.8769V48.7889C0 48.495 0.238749 48.2578 0.534512 48.2578H80.4655C80.7613 48.2578 81 48.495 81 48.7889V53.8769C81 55.0489 80.0414 56.0014 78.862 56.0014ZM1.06902 49.3236V53.8805C1.06902 54.4647 1.55009 54.9427 2.13805 54.9427H78.862C79.4499 54.9427 79.931 54.4647 79.931 53.8805V49.3236H1.06902Z"
            fill="#17324D"
          />
          <path
            id="Vector_6"
            d="M75.2528 49.3222C74.957 49.3222 74.7182 49.085 74.7182 48.7911V3.07334C74.7182 1.9651 73.8096 1.06222 72.6942 1.06222H8.29617C7.18082 1.06222 6.27215 1.9651 6.27215 3.07334V48.7911C6.27215 49.085 6.0334 49.3222 5.73764 49.3222C5.44187 49.3222 5.20312 49.085 5.20312 48.7911V3.07334C5.20312 1.37734 6.59286 0 8.29617 0H72.6942C74.4011 0 75.7873 1.37734 75.7873 3.07334V48.7911C75.7873 49.085 75.5485 49.3222 75.2528 49.3222Z"
            fill="#17324D"
          />
          <path
            id="Vector_7"
            d="M23.218 22.9146H12.0111C11.7153 22.9146 11.4766 22.6773 11.4766 22.3835V11.2479C11.4766 10.954 11.7153 10.7168 12.0111 10.7168H23.218C23.5138 10.7168 23.7525 10.954 23.7525 11.2479V22.3835C23.7525 22.6773 23.5138 22.9146 23.218 22.9146ZM12.5456 21.8524H22.6835V11.779H12.5456V21.8524Z"
            fill="#17324D"
          />
          <g id="Group_2">
            <path
              id="Vector_8"
              d="M33.1283 33.4702C32.8325 33.4702 32.5938 33.2329 32.5938 32.939V23.496C32.5938 23.2021 32.8325 22.9648 33.1283 22.9648C33.424 22.9648 33.6628 23.2021 33.6628 23.496V32.939C33.6628 33.2329 33.424 33.4702 33.1283 33.4702Z"
              fill="#17324D"
            />
            <path
              id="Vector_9"
              d="M66.0571 33.4706C65.7614 33.4706 65.5226 33.2334 65.5226 32.9395V23.4964C65.5226 23.3618 65.5725 23.2344 65.6652 23.1352L67.2473 21.4286C67.2473 21.4286 67.2651 21.4074 67.2758 21.4003C67.3542 21.3259 67.4006 21.2232 67.4006 21.117V19.2546C67.4006 19.0422 67.2259 18.8687 67.0121 18.8687H63.4024C63.2029 18.8687 63.0211 18.7589 62.9285 18.5819L59.8247 12.6689C59.308 12.0138 58.5027 11.6208 57.6653 11.6208H41.5266C40.6856 11.6208 39.8839 12.0103 39.3672 12.6689L36.2634 18.5819C36.1708 18.7589 35.989 18.8687 35.7895 18.8687H32.1798C31.9659 18.8687 31.7913 19.0422 31.7913 19.2546V21.117C31.7913 21.2232 31.8377 21.3259 31.9161 21.4003C31.9267 21.4109 31.9374 21.418 31.9446 21.4286L33.5267 23.1352C33.7263 23.3512 33.712 23.6876 33.4947 23.8859C33.2773 24.0841 32.9388 24.07 32.7392 23.854L31.1677 22.158C30.8827 21.8854 30.7188 21.5065 30.7188 21.1135V19.2511C30.7188 18.4509 31.3744 17.8029 32.1762 17.8029H35.4652L38.4407 12.1342C38.4549 12.1094 38.4692 12.0811 38.487 12.0599C39.2032 11.1216 40.34 10.5586 41.5266 10.5586H57.6653C58.8519 10.5586 59.9887 11.118 60.7049 12.0599C60.7227 12.0846 60.7405 12.1094 60.7512 12.1342L63.7267 17.8029H67.0157C67.821 17.8029 68.4731 18.4544 68.4731 19.2511V21.1135C68.4731 21.5065 68.3092 21.8854 68.0242 22.158L66.5952 23.7017V32.9395C66.5952 33.2334 66.3565 33.4706 66.0607 33.4706H66.0571Z"
              fill="#17324D"
            />
            <path
              id="Vector_10"
              d="M63.1539 36.707C61.2581 36.707 59.7188 35.1739 59.7188 33.2937V32.9432C59.7188 32.6493 59.9575 32.4121 60.2533 32.4121C60.549 32.4121 60.7878 32.6493 60.7878 32.9432V33.2937C60.7878 34.5897 61.8497 35.6448 63.1539 35.6448C64.4581 35.6448 65.52 34.5897 65.52 33.2937V32.9432C65.52 32.6493 65.7587 32.4121 66.0545 32.4121C66.3503 32.4121 66.589 32.6493 66.589 32.9432V33.2937C66.589 35.1774 65.0461 36.707 63.1539 36.707Z"
              fill="#17324D"
            />
            <path
              id="Vector_11"
              d="M36.0289 36.707C34.1331 36.707 32.5938 35.1739 32.5938 33.2937V32.9432C32.5938 32.6493 32.8325 32.4121 33.1283 32.4121C33.424 32.4121 33.6628 32.6493 33.6628 32.9432V33.2937C33.6628 34.5897 34.7247 35.6448 36.0289 35.6448C37.3331 35.6448 38.395 34.5897 38.395 33.2937V32.9432C38.395 32.6493 38.6337 32.4121 38.9295 32.4121C39.2253 32.4121 39.464 32.6493 39.464 32.9432V33.2937C39.464 35.1774 37.9211 36.707 36.0289 36.707Z"
              fill="#17324D"
            />
            <path
              id="Vector_12"
              d="M62.9726 33.4704H36.222C35.9262 33.4704 35.6875 33.2332 35.6875 32.9393C35.6875 32.6454 35.9262 32.4082 36.222 32.4082H62.9726C63.2683 32.4082 63.5071 32.6454 63.5071 32.9393C63.5071 33.2332 63.2683 33.4704 62.9726 33.4704Z"
              fill="#17324D"
            />
          </g>
          <path
            id="Vector_13"
            d="M58.7131 19.4704H40.472C40.1762 19.4704 39.9375 19.2332 39.9375 18.9393C39.9375 18.6454 40.1762 18.4082 40.472 18.4082H58.7131C59.0089 18.4082 59.2476 18.6454 59.2476 18.9393C59.2476 19.2332 59.0089 19.4704 58.7131 19.4704Z"
            fill="#17324D"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1089_2380">
          <rect width="81" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function SvgConducenti() {
  return (
    <svg
      width="49"
      height="56"
      viewBox="0 0 49 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Modalit&#195;&#160;_Isolamento" clipPath="url(#clip0_1089_2330)">
        <path
          id="Vector"
          d="M28.0391 7.56445V26.3889H46.5727V7.56445H28.0391ZM41.8151 21.5567H32.799V12.3991H41.8151V21.5567Z"
          fill="#A6CAED"
        />
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector_2"
              d="M28.7195 17.6169L25.2378 17.6121L20.6144 17.6169H20.612C19.8234 17.6169 19.0678 17.318 18.484 16.7776L17.1845 15.5702C17.0409 15.4363 17.0315 15.2091 17.1633 15.0633C17.2952 14.9174 17.5188 14.9078 17.6624 15.0417L18.9618 16.2492C19.4138 16.67 20 16.8996 20.612 16.8996L25.2354 16.8948L28.7171 16.8996H28.7195C29.3315 16.8996 29.9177 16.6676 30.3697 16.2492L31.6691 15.0417C31.8127 14.9078 32.0363 14.9174 32.1682 15.0633C32.3 15.2091 32.2906 15.4363 32.147 15.5702L30.8475 16.7776C30.2661 17.318 29.5104 17.6169 28.7195 17.6169Z"
              fill="#17324D"
            />
            <path
              id="Vector_3"
              d="M36.8678 24.0213H31.564C31.3687 24.0213 31.2109 23.8611 31.2109 23.6627V22.7158C31.2109 21.5921 32.0372 20.6237 33.1319 20.4611L36.8207 19.9447C37.0161 19.9184 37.1926 20.0546 37.2185 20.2507C37.2444 20.4468 37.1102 20.6285 36.9172 20.6548L33.2307 21.1712C32.4845 21.2812 31.9172 21.9459 31.9172 22.7158V23.304H36.8678C37.0632 23.304 37.2209 23.4642 37.2209 23.6627C37.2209 23.8611 37.0632 24.0213 36.8678 24.0213Z"
              fill="#17324D"
            />
            <path
              id="Vector_4"
              d="M17.4311 24.0189H12.1274C11.932 24.0189 11.7743 23.8587 11.7743 23.6603C11.7743 23.4618 11.932 23.3016 12.1274 23.3016H17.078V22.7135C17.078 21.9435 16.513 21.2788 15.7621 21.1689L12.078 20.6548C11.8849 20.6285 11.7507 20.4468 11.7766 20.2507C11.8025 20.0546 11.9814 19.9184 12.1745 19.9447L15.8609 20.4611C16.9579 20.6237 17.7842 21.5921 17.7842 22.7158V23.6627C17.7842 23.8611 17.6265 24.0213 17.4311 24.0213V24.0189Z"
              fill="#17324D"
            />
            <path
              id="Vector_5"
              d="M9.26717 27.302C9.07179 27.302 8.91406 27.1419 8.91406 26.9434V18.0129C8.91406 17.8145 9.07179 17.6543 9.26717 17.6543C9.46256 17.6543 9.62028 17.8145 9.62028 18.0129V26.9434C9.62028 27.1419 9.46256 27.302 9.26717 27.302Z"
              fill="#17324D"
            />
            <path
              id="Vector_6"
              d="M39.7318 27.3032C39.5364 27.3032 39.3787 27.143 39.3787 26.9446V18.0141C39.3787 17.9233 39.4116 17.8372 39.4728 17.7702L40.9371 16.1539C40.9371 16.1539 40.9488 16.1396 40.9559 16.1348C41.0571 16.0391 41.116 15.9029 41.116 15.7618V13.9996C41.116 13.7175 40.89 13.4903 40.6146 13.4903H37.2741C37.1423 13.4903 37.0222 13.4162 36.961 13.2966L34.0844 7.6921C33.5806 7.02979 32.7896 6.63766 31.9657 6.63766H17.0362C16.2123 6.63766 15.4213 7.03218 14.9175 7.6921L12.0408 13.2966C11.9796 13.4162 11.8596 13.4903 11.7278 13.4903H8.38733C8.10955 13.4903 7.88591 13.7199 7.88591 13.9996V15.7618C7.88591 15.9029 7.94476 16.0391 8.04599 16.1348C8.05305 16.142 8.06011 16.1467 8.06482 16.1539L9.52905 17.7702C9.66088 17.9161 9.65146 18.1432 9.50786 18.2771C9.36427 18.411 9.14063 18.4015 9.0088 18.2556L7.55398 16.6489C7.31622 16.4193 7.17969 16.0941 7.17969 15.7594V13.9972C7.17969 13.3206 7.72112 12.7706 8.38733 12.7706H11.5135L14.3055 7.33106C14.3149 7.31432 14.3243 7.29519 14.3361 7.28085C14.9717 6.42726 15.9816 5.91797 17.0362 5.91797H31.9657C33.0203 5.91797 34.0279 6.42726 34.6658 7.28085C34.6776 7.29759 34.6894 7.31432 34.6964 7.33106L37.4884 12.7706H40.6146C41.2808 12.7706 41.8222 13.3206 41.8222 13.9972V15.7594C41.8222 16.0941 41.6857 16.4169 41.4479 16.6489L40.0849 18.1528V26.9446C40.0849 27.143 39.9272 27.3032 39.7318 27.3032Z"
              fill="#17324D"
            />
            <path
              id="Vector_7"
              d="M37.0446 30.3614C35.3708 30.3614 34.0078 28.977 34.0078 27.2769V26.9446C34.0078 26.7461 34.1655 26.5859 34.3609 26.5859C34.5563 26.5859 34.714 26.7461 34.714 26.9446V27.2769C34.714 28.5824 35.7592 29.644 37.0446 29.644C38.3299 29.644 39.3751 28.5824 39.3751 27.2769V26.9446C39.3751 26.7461 39.5328 26.5859 39.7282 26.5859C39.9236 26.5859 40.0813 26.7461 40.0813 26.9446V27.2769C40.0813 28.977 38.7183 30.3614 37.0446 30.3614Z"
              fill="#17324D"
            />
            <path
              id="Vector_8"
              d="M11.9508 30.3614C10.2747 30.3614 8.91406 28.977 8.91406 27.2769V26.9446C8.91406 26.7461 9.07179 26.5859 9.26717 26.5859C9.46256 26.5859 9.62028 26.7461 9.62028 26.9446V27.2769C9.62028 28.5824 10.6655 29.644 11.9508 29.644C13.2361 29.644 14.2813 28.5824 14.2813 27.2769V26.9446C14.2813 26.7461 14.4391 26.5859 14.6345 26.5859C14.8298 26.5859 14.9876 26.7461 14.9876 26.9446V27.2769C14.9876 28.977 13.6246 30.3614 11.9508 30.3614Z"
              fill="#17324D"
            />
            <path
              id="Vector_9"
              d="M36.8694 27.3032H12.1187C11.9233 27.3032 11.7656 27.143 11.7656 26.9446C11.7656 26.7461 11.9233 26.5859 12.1187 26.5859H36.8694C37.0648 26.5859 37.2226 26.7461 37.2226 26.9446C37.2226 27.143 37.0648 27.3032 36.8694 27.3032Z"
              fill="#17324D"
            />
            <path
              id="Vector_10"
              d="M26.6123 24.022H22.3844C22.189 24.022 22.0312 23.8618 22.0312 23.6633C22.0312 23.4649 22.189 23.3047 22.3844 23.3047H26.6123C26.8077 23.3047 26.9654 23.4649 26.9654 23.6633C26.9654 23.8618 26.8077 24.022 26.6123 24.022Z"
              fill="#17324D"
            />
            <path
              id="Vector_11"
              d="M34.2196 13.4907H14.775C14.5796 13.4907 14.4219 13.3305 14.4219 13.1321C14.4219 12.9336 14.5796 12.7734 14.775 12.7734H34.2196C34.415 12.7734 34.5727 12.9336 34.5727 13.1321C34.5727 13.3305 34.415 13.4907 34.2196 13.4907Z"
              fill="#17324D"
            />
          </g>
          <path
            id="Vector_12"
            d="M44.5726 36.2813H4.4357C2.30291 36.2813 0.570312 34.5191 0.570312 32.3552V3.92605C0.570313 1.76218 2.30526 0 4.4357 0H44.5726C46.7054 0 48.438 1.76218 48.438 3.92605V32.3528C48.438 34.5191 46.7031 36.2789 44.5726 36.2789V36.2813ZM4.4357 0.717305C2.69369 0.717305 1.27653 2.1567 1.27653 3.92605V32.3528C1.27653 34.1222 2.69369 35.5616 4.4357 35.5616H44.5726C46.3146 35.5616 47.7318 34.1222 47.7318 32.3528V3.92605C47.7318 2.1567 46.3146 0.717305 44.5726 0.717305H4.4357Z"
            fill="#17324D"
          />
          <path
            id="Vector_13"
            d="M38.6672 41.7839H10.3219C10.2042 41.7839 10.0959 41.7241 10.03 41.6261C9.96404 41.5281 9.94992 41.4037 9.99465 41.2914L12.1392 35.7872C12.2098 35.6031 12.417 35.5123 12.5982 35.5864C12.7795 35.6581 12.869 35.8685 12.796 36.0526L10.8445 41.0666H38.1517L36.2002 36.0526C36.1295 35.8685 36.2167 35.6605 36.3979 35.5864C36.5792 35.5123 36.784 35.6031 36.857 35.7872L39.0015 41.2914C39.0439 41.4014 39.0298 41.5257 38.9662 41.6261C38.9003 41.7241 38.792 41.7839 38.6743 41.7839H38.6672Z"
            fill="#17324D"
          />
          <path
            id="Vector_14"
            d="M46.973 55.9994H2.02672C1.30167 55.9994 0.649592 55.6216 0.282357 54.988C-0.084878 54.3544 -0.0942943 53.5916 0.256462 52.9484L4.35961 45.4263C4.42082 45.3115 4.54087 45.2422 4.66799 45.2422H44.327C44.4542 45.2422 44.5742 45.3139 44.6354 45.4263L48.7386 52.9484C49.0893 53.5916 49.0799 54.3544 48.7127 54.988C48.3454 55.6216 47.6934 55.9994 46.9683 55.9994H46.973ZM4.8775 45.9595L0.873229 53.2951C0.644884 53.7136 0.651946 54.2109 0.889708 54.6221C1.12982 55.0358 1.55356 55.2821 2.02437 55.2821H46.9707C47.4415 55.2821 47.8652 55.0358 48.1053 54.6221C48.3454 54.2085 48.3501 53.7136 48.1218 53.2951L44.1175 45.9595H4.8775Z"
            fill="#17324D"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1089_2330">
          <rect width="49" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function SvgAutotrasporto() {
  return (
    <svg
      width="65"
      height="54"
      viewBox="0 0 65 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Modalit&#195;&#160;_Isolamento" clipPath="url(#clip0_1089_2300)">
        <path
          id="Vector"
          d="M17.0703 11.2227V32.3719H37.7293V11.2227H17.0703ZM32.4262 26.9429H22.3761V16.6544H32.4262V26.9429Z"
          fill="#A6CAED"
        />
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector_2"
              d="M52.0855 11.9702C51.3954 11.9702 50.805 11.441 50.7184 10.7398L50.7027 10.6136C50.5032 9.05821 49.2017 7.88698 47.6693 7.88698C46.1368 7.88698 44.8353 9.05821 44.6359 10.6136L44.6202 10.7371C44.5309 11.4383 43.9432 11.9675 43.253 11.9675H42.8568C42.0958 11.9675 41.4766 11.3335 41.4766 10.5545V4.65268C41.4766 3.9999 41.9961 3.4707 42.6311 3.4707H52.3112C52.9488 3.4707 53.4658 4.00259 53.4658 4.65268V10.5545C53.4658 11.3335 52.8465 11.9675 52.0855 11.9675V11.9702ZM47.6693 7.08378C49.5953 7.08378 51.2327 8.55856 51.482 10.5115L51.4978 10.6378C51.5371 10.9386 51.789 11.167 52.0855 11.167C52.4135 11.167 52.6786 10.8956 52.6786 10.5598V4.65805C52.6786 4.4512 52.5133 4.28197 52.3112 4.28197H42.6311C42.4291 4.28197 42.2638 4.4512 42.2638 4.65805V10.5598C42.2638 10.8956 42.5288 11.167 42.8568 11.167H43.253C43.5495 11.167 43.8015 10.9386 43.8408 10.6378L43.8566 10.5142C44.1058 8.55856 45.7459 7.08646 47.6693 7.08646V7.08378Z"
              fill="#17324D"
            />
            <path
              id="Vector_3"
              d="M61.9398 54.0006H33.406C31.7161 54.0006 30.3438 52.5929 30.3438 50.8657V8.9728C30.3438 7.24283 31.7187 5.83789 33.406 5.83789H41.8738C42.0916 5.83789 42.2674 6.01787 42.2674 6.24084C42.2674 6.4638 42.0916 6.64378 41.8738 6.64378H33.406C32.1517 6.64378 31.131 7.68875 31.131 8.9728V50.8683C31.131 52.1524 32.1517 53.1974 33.406 53.1974H61.9398C63.1941 53.1974 64.2148 52.1524 64.2148 50.8683V8.9728C64.2148 7.68875 63.1941 6.64378 61.9398 6.64378H53.0758C52.858 6.64378 52.6822 6.4638 52.6822 6.24084C52.6822 6.01787 52.858 5.83789 53.0758 5.83789H61.9398C63.6296 5.83789 65.002 7.24551 65.002 8.9728V50.8683C65.002 52.5983 63.627 54.0032 61.9398 54.0032V54.0006Z"
              fill="#17324D"
            />
            <path
              id="Vector_4"
              d="M53.5389 49.9544H34.6905C34.4727 49.9544 34.2969 49.7744 34.2969 49.5514V10.2858C34.2969 10.0628 34.4727 9.88281 34.6905 9.88281C34.9083 9.88281 35.0841 10.0628 35.0841 10.2858V49.1458H53.3762L60.2617 42.0969V10.2858C60.2617 10.0628 60.4375 9.88281 60.6553 9.88281C60.8731 9.88281 61.0489 10.0628 61.0489 10.2858V42.2635C61.0489 42.3709 61.0069 42.473 60.9335 42.5482L53.8171 49.8335C53.7436 49.9087 53.6439 49.9517 53.5389 49.9517V49.9544Z"
              fill="#17324D"
            />
            <path
              id="Vector_5"
              d="M41.5047 30.8062C41.3997 30.8062 41.3 30.7632 41.2266 30.688L39.7099 29.1353C39.555 28.9768 39.555 28.7216 39.7099 28.5658C39.8647 28.41 40.114 28.4073 40.2662 28.5658L41.4968 29.8257L44.3544 26.7257C44.504 26.5645 44.7533 26.5565 44.9107 26.7096C45.0681 26.8627 45.076 27.1179 44.9264 27.2791L41.7907 30.6799C41.7172 30.7578 41.6175 30.8035 41.51 30.8062H41.5047Z"
              fill="#17324D"
            />
            <path
              id="Vector_6"
              d="M40.1443 21.3474C40.0445 21.3474 39.9422 21.3071 39.8661 21.2292C39.7113 21.0707 39.7113 20.8155 39.8661 20.6597L43.6054 16.8318C43.7602 16.6733 44.0095 16.6733 44.1617 16.8318C44.3139 16.9903 44.3165 17.2454 44.1617 17.4013L40.4224 21.2292C40.3463 21.3071 40.244 21.3474 40.1443 21.3474Z"
              fill="#17324D"
            />
            <path
              id="Vector_7"
              d="M43.8835 21.3484C43.7838 21.3484 43.6815 21.3081 43.6054 21.2302L39.8661 17.4022C39.7113 17.2437 39.7113 16.9885 39.8661 16.8327C40.0209 16.6769 40.2702 16.6742 40.4224 16.8327L44.1617 20.6607C44.3165 20.8192 44.3165 21.0744 44.1617 21.2302C44.0856 21.3081 43.9832 21.3484 43.8835 21.3484Z"
              fill="#17324D"
            />
            <path
              id="Vector_8"
              d="M40.1443 41.0759C40.0445 41.0759 39.9422 41.0356 39.8661 40.9577C39.7113 40.7993 39.7113 40.5441 39.8661 40.3883L43.6054 36.5603C43.7602 36.4018 44.0095 36.4018 44.1617 36.5603C44.3139 36.7188 44.3165 36.974 44.1617 37.1298L40.4224 40.9577C40.3463 41.0356 40.244 41.0759 40.1443 41.0759Z"
              fill="#17324D"
            />
            <path
              id="Vector_9"
              d="M43.8835 41.0749C43.7838 41.0749 43.6815 41.0346 43.6054 40.9567L39.8661 37.1288C39.7113 36.9703 39.7113 36.7151 39.8661 36.5593C40.0209 36.4035 40.2702 36.4008 40.4224 36.5593L44.1617 40.3872C44.3165 40.5457 44.3165 40.8009 44.1617 40.9567C44.0856 41.0346 43.9832 41.0749 43.8835 41.0749Z"
              fill="#17324D"
            />
            <path
              id="Vector_10"
              d="M57.374 21.3489H46.5499C46.3321 21.3489 46.1562 21.1689 46.1562 20.9459C46.1562 20.723 46.3321 20.543 46.5499 20.543H57.374C57.5918 20.543 57.7676 20.723 57.7676 20.9459C57.7676 21.1689 57.5918 21.3489 57.374 21.3489Z"
              fill="#17324D"
            />
            <path
              id="Vector_11"
              d="M57.374 31.0325H46.5499C46.3321 31.0325 46.1562 30.8525 46.1562 30.6295C46.1562 30.4065 46.3321 30.2266 46.5499 30.2266H57.374C57.5918 30.2266 57.7676 30.4065 57.7676 30.6295C57.7676 30.8525 57.5918 31.0325 57.374 31.0325Z"
              fill="#17324D"
            />
          </g>
          <path
            id="Vector_12"
            d="M21.0059 28.7549C19.8015 28.7549 18.6522 28.2982 17.7626 27.4655L15.7132 25.5475C15.5532 25.397 15.5427 25.1418 15.6896 24.978C15.8366 24.8141 16.0858 24.8034 16.2459 24.9538L18.2953 26.8718C19.0379 27.5676 20.0009 27.949 21.0059 27.949H21.0085L27.3954 27.941C27.6132 27.941 27.789 28.1209 27.789 28.3439C27.789 28.5669 27.6132 28.7468 27.3954 28.7468L21.0085 28.7549H21.0033H21.0059Z"
            fill="#17324D"
          />
          <path
            id="Vector_13"
            d="M15.996 38.9285H7.63579C7.418 38.9285 7.24219 38.7485 7.24219 38.5255C7.24219 38.3026 7.418 38.1226 7.63579 38.1226H15.6024V37.0212C15.6024 35.7157 14.6525 34.5901 13.3903 34.402L7.58331 33.5827C7.36814 33.5532 7.21857 33.349 7.24744 33.1287C7.2763 32.9085 7.4731 32.7553 7.6909 32.7849L13.5005 33.6042C15.1484 33.8514 16.3896 35.3181 16.3896 37.0212V38.5255C16.3896 38.7485 16.2138 38.9285 15.996 38.9285Z"
            fill="#17324D"
          />
          <path
            id="Vector_14"
            d="M3.12798 44.1426C2.91019 44.1426 2.73438 43.9627 2.73438 43.7397V29.5533C2.73438 29.3304 2.91019 29.1504 3.12798 29.1504C3.34578 29.1504 3.52159 29.3304 3.52159 29.5533V43.7397C3.52159 43.9627 3.34578 44.1426 3.12798 44.1426Z"
            fill="#17324D"
          />
          <path
            id="Vector_15"
            d="M3.13048 29.9544C3.02551 29.9544 2.91793 29.9114 2.84183 29.8255L0.543176 27.2708C0.196803 26.935 0 26.4649 0 25.976V23.1769C0 22.1937 0.781963 21.3959 1.73974 21.3959H6.76739L11.2151 12.6681C11.2256 12.6493 11.2361 12.6278 11.2492 12.6117C12.2201 11.2981 13.7631 10.5137 15.3742 10.5137H27.7676C27.9853 10.5137 28.1612 10.6937 28.1612 10.9166C28.1612 11.1396 27.9853 11.3196 27.7676 11.3196H15.3742C14.0202 11.3196 12.7213 11.975 11.8974 13.071L7.35517 21.9869C7.28695 22.1212 7.15312 22.2045 7.00618 22.2045H1.73974C1.21493 22.2045 0.787211 22.6423 0.787211 23.1796V25.9787C0.787211 26.25 0.89742 26.5106 1.0916 26.6933C1.09947 26.7013 1.10734 26.7067 1.11259 26.7147L3.41912 29.2802C3.56607 29.444 3.55557 29.6992 3.3955 29.8497C3.31941 29.9222 3.22494 29.9571 3.12785 29.9571L3.13048 29.9544Z"
            fill="#17324D"
          />
          <path
            id="Vector_16"
            d="M7.35793 48.9974C4.80736 48.9974 2.73438 46.8753 2.73438 44.2642V43.735C2.73438 43.512 2.91019 43.332 3.12798 43.332C3.34578 43.332 3.52159 43.512 3.52159 43.735V44.2642C3.52159 46.4293 5.24295 48.1915 7.35793 48.1915C9.4729 48.1915 11.1943 46.4293 11.1943 44.2642V43.735C11.1943 43.512 11.3701 43.332 11.5879 43.332C11.8057 43.332 11.9815 43.512 11.9815 43.735V44.2642C11.9815 46.8753 9.90849 48.9974 7.35793 48.9974Z"
            fill="#17324D"
          />
          <path
            id="Vector_17"
            d="M27.4 44.1418H7.63579C7.418 44.1418 7.24219 43.9618 7.24219 43.7389C7.24219 43.5159 7.418 43.3359 7.63579 43.3359H27.4C27.6178 43.3359 27.7936 43.5159 27.7936 43.7389C27.7936 43.9618 27.6178 44.1418 27.4 44.1418Z"
            fill="#17324D"
          />
          <path
            id="Vector_18"
            d="M27.1376 38.927H23.8077C23.5899 38.927 23.4141 38.747 23.4141 38.524C23.4141 38.3011 23.5899 38.1211 23.8077 38.1211H27.1376C27.3554 38.1211 27.5312 38.3011 27.5312 38.524C27.5312 38.747 27.3554 38.927 27.1376 38.927Z"
            fill="#17324D"
          />
          <path
            id="Vector_19"
            d="M27.6463 22.2024H11.8155C11.5977 22.2024 11.4219 22.0224 11.4219 21.7994C11.4219 21.5765 11.5977 21.3965 11.8155 21.3965H27.6463C27.8641 21.3965 28.0399 21.5765 28.0399 21.7994C28.0399 22.0224 27.8641 22.2024 27.6463 22.2024Z"
            fill="#17324D"
          />
          <path
            id="Vector_20"
            d="M50.6001 0.80589H44.347C44.1292 0.80589 43.9534 0.625908 43.9534 0.402945C43.9534 0.179982 44.1292 0 44.347 0H50.6001C50.8178 0 50.9937 0.179982 50.9937 0.402945C50.9937 0.625908 50.8178 0.80589 50.6001 0.80589Z"
            fill="#17324D"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1089_2300">
          <rect width="65" height="54" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function SvgNautica() {
  return (
    <svg
      width="55"
      height="56"
      viewBox="0 0 55 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 1100">
        <path
          id="Vector"
          d="M34.9922 24V41.8993H52.5636V24H34.9922ZM48.053 37.3046H39.505V28.597H48.053V37.3046Z"
          fill="#A6CAED"
        />
        <g id="directions_boat">
          <mask
            id="mask0_1230_2623"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="55"
            height="56"
          >
            <rect id="Bounding box" width="54.99" height="56" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_1230_2623)">
            <path
              id="directions_boat_2"
              d="M9.78075 42.5L6.51337 29.9259C6.42959 29.537 6.46101 29.1265 6.60762 28.6944C6.75423 28.2623 7.01604 27.9815 7.39305 27.8519L10.6604 26.6852V15.6667C10.6604 14.5432 11.0165 13.6142 11.7286 12.8796C12.4407 12.1451 13.3414 11.7778 14.4305 11.7778H23.2273V4H31.7727V11.7778H40.5695C41.6586 11.7778 42.5593 12.1451 43.2714 12.8796C43.9835 13.6142 44.3396 14.5432 44.3396 15.6667V26.6852L47.6069 27.8519C48.0677 28.0247 48.4029 28.3164 48.6123 28.7269C48.8217 29.1373 48.8636 29.537 48.738 29.9259L45.2192 42.5C43.8788 41.8519 42.6745 41.0525 41.6063 40.1019C40.5381 39.1512 39.1872 37.7037 37.5535 35.7593C36.0455 37.6605 34.527 39.2809 32.998 40.6204C31.469 41.9599 29.6364 42.6296 27.5 42.6296C25.3636 42.6296 23.531 41.9599 22.002 40.6204C20.473 39.2809 18.9545 37.6605 17.4465 35.7593C15.8547 37.7037 14.5143 39.1512 13.4251 40.1019C12.336 41.0525 11.1212 41.8519 9.78075 42.5ZM4 53V51.1852H7.39305C9.15241 51.1852 10.8908 50.9043 12.6083 50.3426C14.3258 49.7809 15.9385 48.9383 17.4465 47.8148C18.9545 48.9383 20.5673 49.7593 22.2848 50.2778C24.0022 50.7963 25.7406 51.0556 27.5 51.0556C29.2594 51.0556 30.9978 50.7963 32.7152 50.2778C34.4327 49.7593 36.0455 48.9383 37.5535 47.8148C39.0615 48.9383 40.6742 49.7809 42.3917 50.3426C44.1092 50.9043 45.8476 51.1852 47.6069 51.1852H51V53H47.6069C45.8476 53 44.1301 52.784 42.4545 52.3519C40.779 51.9198 39.1453 51.2716 37.5535 50.4074C35.9617 51.2716 34.3175 51.9198 32.621 52.3519C30.9245 52.784 29.2175 53 27.5 53C25.7825 53 24.0755 52.784 22.379 52.3519C20.6825 51.9198 19.0383 51.2716 17.4465 50.4074C15.8547 51.2716 14.221 51.9198 12.5455 52.3519C10.8699 52.784 9.15241 53 7.39305 53H4ZM12.4198 26.037L27.5 20.9815L42.5802 26.037V15.6667C42.5802 15.0617 42.3917 14.5648 42.0147 14.1759C41.6377 13.787 41.156 13.5926 40.5695 13.5926H14.4305C13.844 13.5926 13.3623 13.787 12.9853 14.1759C12.6083 14.5648 12.4198 15.0617 12.4198 15.6667V26.037ZM27.5 40.8148C29.4688 40.8148 31.113 40.1127 32.4325 38.7083C33.752 37.304 35.459 35.3704 37.5535 32.9074C39.5223 35.2407 40.8732 36.8179 41.6063 37.6389C42.3393 38.4599 43.2086 39.1728 44.2139 39.7778L46.9786 29.537L27.5 22.9259L8.02139 29.537L10.7861 39.7778C11.7914 39.1728 12.6607 38.4815 13.3937 37.7037C14.1268 36.9259 15.4777 35.3272 17.4465 32.9074C19.541 35.3704 21.248 37.304 22.5675 38.7083C23.887 40.1127 25.5312 40.8148 27.5 40.8148Z"
              fill="#001A33"
              fillOpacity="0.75"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
